import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const selectOmniplatformReportBuilder = (state: RootState) => state.omniplatformReportBuilder;

export const selectOmniplatformTemplates = createSelector(
  [selectOmniplatformReportBuilder],
  ({ templates, templatesRequestId }) => ({
    templates,
    loadingTemplates: !!templatesRequestId,
  }),
);

export const selectOmniplatformCampaigns = createSelector(
  [selectOmniplatformReportBuilder],
  ({ campaigns, campaignsRequestId }) => ({
    campaigns,
    loadingCampaigns: !!campaignsRequestId,
  }),
);

export const selectOmniplatformEvents = createSelector(
  [selectOmniplatformReportBuilder],
  ({ events, eventsRequestId }) => ({
    events,
    loadingEvents: !!eventsRequestId,
  }),
);

export const selectOmniplatformGeneratedReports = createSelector(
  [selectOmniplatformReportBuilder],
  ({ generatedReports, generatedReportsRequestId, generatedReportsTotal }) => ({
    generatedReports,
    loadingGeneratedReports: !!generatedReportsRequestId,
    generatedReportsTotal,
  }),
);

export const selectOmniplatformScheduledReports = createSelector(
  [selectOmniplatformReportBuilder],
  ({ scheduledReports, scheduledReportsRequestId, scheduledReportsTotal }) => ({
    scheduledReports,
    loadingScheduledReports: !!scheduledReportsRequestId,
    scheduledReportsTotal,
  }),
);
